import { ALLOWLIST_HOUSEHOLD_INSIGHTS } from '@openx/constants/feature-flag-keys.ts';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext.tsx';

export const useHouseholdInsightsAccess = (): boolean => {
  const { isGrowthbookFeatureOn } = usePermissionContext();

  // An empty allowlist opens the page to everyone; a missing flag keeps it hidden
  return isGrowthbookFeatureOn(ALLOWLIST_HOUSEHOLD_INSIGHTS, undefined, { emptyAllowlistMeansEnabled: true });
};
